"use client";

// src/context/react/ContentPartContext.ts
import { createContext } from "react";
import { createContextHook } from "./utils/createContextHook.js";
import { createStateHookForRuntime } from "./utils/createStateHookForRuntime.js";
var ContentPartContext = createContext(
  null
);
var useContentPartContext = createContextHook(
  ContentPartContext,
  "a component passed to <MessagePrimitive.Content components={...}>"
);
function useContentPartRuntime(options) {
  const context = useContentPartContext(options);
  if (!context) return null;
  return context.useContentPartRuntime();
}
var useContentPart = createStateHookForRuntime(useContentPartRuntime);
export {
  ContentPartContext,
  useContentPart,
  useContentPartRuntime
};
//# sourceMappingURL=ContentPartContext.js.map